import React from 'react';
import {CSSTransition, Transition, TransitionGroup} from "react-transition-group";
import owl from '../../images/alps/owl.png'

import uuid from 'uuid'



function Owl(props) {

    const renderSheep = () => {
        if (props.show && props.show2) {
            return  (

                <div>
                    <img src={owl} style={sheep}/>
                </div>


            )
        }
    }

    return(
        <TransitionGroup>
            <CSSTransition
                key={uuid()}
                timeout={600}
                classNames='fade'>
                {renderSheep}
            </CSSTransition>
        </TransitionGroup>

    )

}


export default Owl



const sheep = {
    position: 'fixed',
    zIndex: -1,
    maxHeight: '90%',
    maxWidth:'100%',
    left:'0',
    right:'0',
    top:'0',
    bottom:'0',
    margin:'auto'
}

